import { useT, LANGUAGES } from "@/lib/i18n";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Languages } from "lucide-react";

export default function LanguageSelect({ compact = false }) {
  const { lang, setLang } = useT();
  return (
    <Select value={lang} onValueChange={setLang}>
      <SelectTrigger
        data-testid="language-select"
        className={`rounded-full border-border bg-background ${compact ? "h-9 px-3 text-xs" : "h-10 px-4 text-sm"}`}
      >
        <Languages className="w-3.5 h-3.5 mr-1.5 text-muted-foreground" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {LANGUAGES.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`lang-opt-${l.code}`}>
            <span className="font-semibold">{l.native}</span>
            <span className="text-muted-foreground text-xs ml-2">{l.label}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
